import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = (window as any).SUPABASE_URL as string | undefined;
const SUPABASE_ANON_KEY = (window as any).SUPABASE_ANON_KEY as string | undefined;
const supabase = SUPABASE_URL && SUPABASE_ANON_KEY ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY) : null;

let introUserIsLoggedIn = false;

const overlay = document.getElementById("intro");
const hum = document.getElementById("intro-hum") as HTMLAudioElement | null;
const voiceover = document.getElementById("intro-voiceover") as HTMLAudioElement | null;

function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function typeLine(el: HTMLElement | null, charDelay = 45, holdAfter = 250) {
  if (!el) return;
  const full = el.dataset.text || el.textContent || "";
  let i = 0;
  return new Promise<void>((resolve) => {
    const tick = () => {
      el.textContent = full.slice(0, i);
      if (i <= full.length) {
        i++;
        setTimeout(tick, charDelay);
      } else {
        setTimeout(resolve, holdAfter);
      }
    };
    el.classList.add("visible");
    tick();
  });
}

async function playSequence(lines: HTMLElement[], charDelay: number, lineDelay: number, finalHold: number) {
  for (let i = 0; i < lines.length; i++) {
    await typeLine(lines[i], charDelay, lineDelay * 0.4);
    if (i < lines.length - 1) await wait(lineDelay);
  }
  if (finalHold) await wait(finalHold);
}

function fadeOutOverlay(target = "/choose_path.html") {
  if (!overlay) return;
  overlay.classList.add("fade-out");
  setTimeout(() => {
    (overlay as HTMLElement).style.display = "none";
    window.location.href = target;
  }, 900);
}

async function playHum() {
  try {
    if (hum) {
      hum.volume = 0.08;
      await hum.play();
    }
  } catch {
    // ignore
  }
}

async function playVoiceover() {
  try {
    if (voiceover) {
      voiceover.volume = 0.4;
      await voiceover.play();
    }
  } catch {
    // ignore
  }
}

async function personaliseIntroText() {
  const line1 = document.getElementById("intro-line-1");
  const line2 = document.getElementById("intro-line-2");
  const line3 = document.getElementById("intro-line-3");
  if (!line1 || !line2 || !line3) return;

  let text1 = "> SIGNAL DETECTED";
  let text2 = "TRAVELLER ID: UNIDENTIFIED";
  let text3 = "OPENING ACCESS PORTAL ...";
  introUserIsLoggedIn = false;

  try {
    if (supabase) {
      const { data } = await supabase.auth.getUser();
      if (data?.user) {
        const { data: traveller, error: tErr } = await supabase
          .from("travellers")
          .select("traveller_id")
          .eq("user_id", data.user.id)
          .single();
        if (!tErr && traveller?.traveller_id) {
          introUserIsLoggedIn = true;
          text1 = "> SIGNAL DETECTED";
          text2 = "TRAVELLER ID: " + traveller.traveller_id.toUpperCase();
          text3 = "CONNECTING ...";
        }
      }
    }
  } catch (e) {
    console.error("intro personalization error:", e);
  }

  line1.textContent = text1;
  line2.textContent = text2;
  line3.textContent = text3;
  line1.dataset.text = text1;
  line2.dataset.text = text2;
  line3.dataset.text = text3;
}

async function runIntro() {
  await personaliseIntroText();
  await playHum();
  const lines = Array.from(document.querySelectorAll<HTMLElement>(".intro-line"));
  if (!lines.length) {
    fadeOutOverlay();
    return;
  }
  playVoiceover();
  await playSequence(lines, 45, 230, 900);
  fadeOutOverlay(introUserIsLoggedIn ? "/index.html" : "/choose_path.html");
}

document.addEventListener("DOMContentLoaded", () => {
  void runIntro();
});
